import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { logout } from "../../actions/authenActions";

const baseURL = process.env.REACT_APP_API_URL || "http://localhost:8000";

export const fetchDashboardFlags = createAsyncThunk(
  "s1DashboardFrame/fetchDashboardFlags",
  async (_, { getState, dispatch, rejectWithValue }) => {
    try {
      const state = getState();
      const license_key = state.authen.loggedInUser.license_key;
      const { data } = await axios.post(
        `${baseURL}/s1_pathology/api/dashboard_flags`,
        { license_key },
      );
      return data;
    } catch (error) {
      if (error.response && error.response.status === 403) dispatch(logout());
      return rejectWithValue(
        error.response?.data || "Failed to fetch dashboard flags",
      );
    }
  },
);

export const fetchLineChartData = createAsyncThunk(
  "s1DashboardFrame/fetchLineChartData",
  async ({ start, end }, { getState, dispatch, rejectWithValue }) => {
    try {
      const state = getState();
      const license_key = state.authen.loggedInUser.license_key;
      const { data } = await axios.post(
        `${baseURL}/s1_pathology/api/dashboard_chart`,
        { license_key, start, end },
      );
      return data;
    } catch (error) {
      if (error.response && error.response.status === 403) dispatch(logout());
      return rejectWithValue(
        error.response?.data || "Failed to fetch chart data",
      );
    }
  },
);

const dashboardFrameSlice = createSlice({
  name: "s1DashboardFrame",
  initialState: {
    flags: [],
    chartData: [],
    loadingFlags: false,
    loadingChart: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardFlags.pending, (state) => {
        state.loadingFlags = true;
      })
      .addCase(fetchDashboardFlags.fulfilled, (state, action) => {
        state.flags = action.payload;
        state.loadingFlags = false;
      })
      .addCase(fetchDashboardFlags.rejected, (state, action) => {
        state.loadingFlags = false;
        state.error = action.error.message;
      })
      .addCase(fetchLineChartData.pending, (state) => {
        state.loadingChart = true;
      })
      .addCase(fetchLineChartData.fulfilled, (state, action) => {
        state.chartData = action.payload;
        state.loadingChart = false;
      })
      .addCase(fetchLineChartData.rejected, (state, action) => {
        state.loadingChart = false;
        state.error = action.error.message;
      });
  },
});

export default dashboardFrameSlice.reducer;
